export const clipPathCode = `44.758% 100%, 43.129% 100%, 43.129% 100%, 43.085%
  99.99%, 43.041% 99.98%, 42.997% 99.969%, 42.953% 99.958%, 42.909% 99.948%,
  42.865% 99.938%, 42.821% 99.929%, 42.777% 99.922%, 42.733% 99.916%, 42.688%
  99.912%, 42.688% 99.912%, 42.238% 99.876%, 41.791% 99.825%, 41.348% 99.76%,
  40.909% 99.68%, 40.473% 99.586%, 40.04% 99.477%, 39.611% 99.354%, 39.186%
  99.217%, 38.763% 99.066%, 38.344% 98.901%, 38.344% 98.901%, 37.284% 98.421%,
  36.285% 97.88%, 35.353% 97.275%, 34.489% 96.604%, 33.696% 95.867%, 32.978%
  95.062%, 32.338% 94.186%, 31.778% 93.238%, 31.302% 92.216%, 30.912% 91.119%,
  30.912% 91.119%, 30.651% 90.455%, 30.304% 89.864%, 29.883% 89.348%, 29.4%
  88.91%, 28.866% 88.551%, 28.295% 88.274%, 27.698% 88.079%, 27.087% 87.97%,
  26.476% 87.948%, 25.874% 88.016%, 25.874% 88.016%, 25.127% 88.135%, 24.383%
  88.206%, 23.642% 88.231%, 22.906% 88.211%, 22.175% 88.147%, 21.448% 88.04%,
  20.727% 87.893%, 20.01% 87.705%, 19.299% 87.478%, 18.594% 87.215%, 18.594%
  87.215%, 17.416% 86.694%, 16.297% 86.104%, 15.238% 85.447%, 14.237% 84.723%,
  13.295% 83.935%, 12.41% 83.084%, 11.582% 82.17%, 10.81% 81.195%, 10.094%
  80.16%, 9.434% 79.068%, 9.434% 79.068%, 8.815% 77.886%, 8.29% 76.692%, 7.862%
  75.485%, 7.534% 74.264%, 7.31% 73.029%, 7.194% 71.78%, 7.188% 70.517%, 7.298%
  69.239%, 7.526% 67.946%, 7.876% 66.637%, 7.876% 66.637%, 8.017% 66.054%,
  8.074% 65.476%, 8.051% 64.908%, 7.951% 64.355%, 7.777% 63.824%, 7.532%
  63.319%, 7.219% 62.848%, 6.84% 62.415%, 6.399% 62.025%, 5.899% 61.686%, 5.899%
  61.686%, 5.26% 61.28%, 4.659% 60.841%, 4.097% 60.37%, 3.573% 59.868%, 3.086%
  59.334%, 2.636% 58.769%, 2.223% 58.173%, 1.847% 57.547%, 1.507% 56.892%,
  1.203% 56.207%, 1.203% 56.207%, 0.822% 55.181%, 0.516% 54.15%, 0.283% 53.112%,
  0.12% 52.07%, 0.028% 51.023%, 0.002% 49.973%, 0.042% 48.919%, 0.145% 47.863%,
  0.311% 46.804%, 0.536% 45.744%, 0.536% 45.744%, 0.93% 44.296%, 1.408% 42.91%,
  1.978% 41.591%, 2.645% 40.343%, 3.415% 39.172%, 4.294% 38.082%, 5.29% 37.08%,
  6.407% 36.171%, 7.653% 35.358%, 9.034% 34.648%, 9.034% 34.648%, 9.181%
  34.577%, 9.323% 34.497%, 9.459% 34.41%, 9.59% 34.315%, 9.716% 34.215%, 9.838%
  34.107%, 9.954% 33.994%, 10.066% 33.876%, 10.174% 33.752%, 10.277% 33.624%,
  10.277% 33.624%, 10.544% 33.243%, 10.762% 32.855%, 10.932% 32.46%, 11.057%
  32.057%, 11.139% 31.648%, 11.178% 31.231%, 11.177% 30.808%, 11.137% 30.377%,
  11.06% 29.939%, 10.948% 29.495%, 10.948% 29.495%, 10.794% 28.909%, 10.669%
  28.322%, 10.573% 27.733%, 10.505% 27.142%, 10.467% 26.549%, 10.457% 25.956%,
  10.476% 25.362%, 10.523% 24.767%, 10.599% 24.172%, 10.704% 23.577%, 10.704%
  23.577%, 10.904% 22.705%, 11.151% 21.857%, 11.446% 21.035%, 11.788% 20.237%,
  12.178% 19.465%, 12.615% 18.718%, 13.101% 17.998%, 13.634% 17.303%, 14.216%
  16.634%, 14.847% 15.992%, 14.847% 15.992%, 15.871% 15.082%, 16.931% 14.288%,
  18.027% 13.612%, 19.16% 13.057%, 20.33% 12.625%, 21.539% 12.318%, 22.787%
  12.139%, 24.076% 12.09%, 25.405% 12.173%, 26.776% 12.391%, 26.776% 12.391%,
  27.446% 12.482%, 28.1% 12.479%, 28.729% 12.386%, 29.327% 12.207%, 29.888%
  11.946%, 30.404% 11.607%, 30.869% 11.193%, 31.277% 10.708%, 31.619% 10.157%,
  31.89% 9.543%, 31.89% 9.543%, 32.24% 8.666%, 32.642% 7.829%, 33.094% 7.034%,
  33.597% 6.28%, 34.148% 5.567%, 34.749% 4.893%, 35.398% 4.26%, 36.094% 3.665%,
  36.838% 3.109%, 37.628% 2.592%, 37.628% 2.592%, 38.646% 2.011%, 39.682%
  1.505%, 40.736% 1.072%, 41.807% 0.712%, 42.895% 0.427%, 44% 0.214%, 45.122%
  0.074%, 46.26% 0.007%, 47.414% 0.011%, 48.585% 0.088%, 48.585% 0.088%, 49.751%
  0.239%, 50.878% 0.465%, 51.965% 0.768%, 53.009% 1.15%, 54.01% 1.614%, 54.968%
  2.16%, 55.88% 2.792%, 56.746% 3.51%, 57.565% 4.317%, 58.335% 5.214%, 58.335%
  5.214%, 58.769% 5.691%, 59.254% 6.09%, 59.779% 6.411%, 60.337% 6.65%, 60.92%
  6.806%, 61.518% 6.876%, 62.123% 6.859%, 62.727% 6.752%, 63.322% 6.553%,
  63.898% 6.259%, 63.898% 6.259%, 64.751% 5.789%, 65.616% 5.402%, 66.492%
  5.094%, 67.379% 4.865%, 68.275% 4.711%, 69.181% 4.63%, 70.095% 4.621%, 71.018%
  4.681%, 71.949% 4.808%, 72.886% 4.999%, 72.886% 4.999%, 74.152% 5.346%,
  75.366% 5.773%, 76.53% 6.279%, 77.644% 6.863%, 78.709% 7.521%, 79.725% 8.252%,
  80.693% 9.055%, 81.614% 9.927%, 82.487% 10.867%, 83.315% 11.872%, 83.315%
  11.872%, 83.883% 12.644%, 84.403% 13.435%, 84.872% 14.247%, 85.287% 15.078%,
  85.646% 15.931%, 85.945% 16.806%, 86.183% 17.704%, 86.356% 18.625%, 86.461%
  19.57%, 86.497% 20.539%, 86.497% 20.539%, 86.531% 21.21%, 86.635% 21.832%,
  86.807% 22.407%, 87.047% 22.934%, 87.355% 23.411%, 87.731% 23.839%, 88.173%
  24.216%, 88.682% 24.542%, 89.258% 24.816%, 89.9% 25.038%, 89.9% 25.038%,
  90.768% 25.315%, 91.606% 25.638%, 92.415% 26.005%, 93.194% 26.418%, 93.941%
  26.876%, 94.658% 27.379%, 95.344% 27.929%, 95.998% 28.525%, 96.62% 29.168%,
  97.211% 29.857%, 97.211% 29.857%, 97.87% 30.745%, 98.441% 31.658%, 98.926%
  32.597%, 99.324% 33.56%, 99.639% 34.547%, 99.871% 35.556%, 100.022% 36.588%,
  100.093% 37.64%, 100.085% 38.713%, 100% 39.806%, 100% 39.806%, 99.879%
  40.643%, 99.704% 41.457%, 99.478% 42.248%, 99.203% 43.018%, 98.879% 43.767%,
  98.508% 44.494%, 98.091% 45.202%, 97.631% 45.89%, 97.129% 46.559%, 96.586%
  47.209%, 96.586% 47.209%, 96.259% 47.623%, 95.995% 48.046%, 95.792% 48.48%,
  95.648% 48.922%, 95.564% 49.373%, 95.536% 49.832%, 95.565% 50.299%, 95.649%
  50.773%, 95.785% 51.254%, 95.974% 51.741%, 95.974% 51.741%, 96.052% 51.905%,
  96.138% 52.063%, 96.232% 52.217%, 96.331% 52.367%, 96.436% 52.513%, 96.543%
  52.657%, 96.653% 52.799%, 96.765% 52.941%, 96.876% 53.083%, 96.986% 53.226%,
  96.986% 53.226%, 97.693% 54.251%, 98.287% 55.303%, 98.773% 56.379%, 99.154%
  57.48%, 99.438% 58.602%, 99.628% 59.745%, 99.731% 60.907%, 99.75% 62.087%,
  99.692% 63.282%, 99.561% 64.493%, 99.561% 64.493%, 99.411% 65.418%, 99.215%
  66.328%, 98.975% 67.22%, 98.69% 68.096%, 98.362% 68.955%, 97.99% 69.796%,
  97.575% 70.62%, 97.117% 71.426%, 96.618% 72.215%, 96.077% 72.985%, 96.077%
  72.985%, 95.547% 73.672%, 94.989% 74.327%, 94.405% 74.949%, 93.792% 75.538%,
  93.151% 76.091%, 92.479% 76.608%, 91.776% 77.087%, 91.041% 77.527%, 90.273%
  77.926%, 89.471% 78.283%, 89.471% 78.283%, 89.196% 78.39%, 88.918% 78.488%,
  88.638% 78.578%, 88.357% 78.662%, 88.074% 78.741%, 87.791% 78.818%, 87.507%
  78.894%, 87.223% 78.969%, 86.94% 79.048%, 86.658% 79.129%, 86.658% 79.129%,
  86.154% 79.316%, 85.684% 79.561%, 85.254% 79.858%, 84.867% 80.203%, 84.527%
  80.59%, 84.24% 81.013%, 84.008% 81.467%, 83.836% 81.947%, 83.729% 82.448%,
  83.691% 82.964%, 83.691% 82.964%, 83.634% 84.086%, 83.48% 85.162%, 83.231%
  86.192%, 82.891% 87.178%, 82.462% 88.119%, 81.949% 89.019%, 81.354% 89.877%,
  80.68% 90.695%, 79.931% 91.474%, 79.111% 92.215%, 79.111% 92.215%, 78.156%
  92.972%, 77.171% 93.655%, 76.154% 94.267%, 75.107% 94.808%, 74.03% 95.278%,
  72.924% 95.678%, 71.789% 96.009%, 70.627% 96.272%, 69.437% 96.467%, 68.221%
  96.595%, 68.221% 96.595%, 67.298% 96.643%, 66.387% 96.642%, 65.487% 96.591%,
  64.6% 96.489%, 63.723% 96.333%, 62.859% 96.123%, 62.007% 95.857%, 61.168%
  95.533%, 60.34% 95.15%, 59.526% 94.706%, 59.526% 94.706%, 59.062% 94.47%,
  58.583% 94.294%, 58.093% 94.179%, 57.598% 94.124%, 57.101% 94.129%, 56.608%
  94.192%, 56.123% 94.313%, 55.651% 94.491%, 55.196% 94.726%, 54.763% 95.018%,
  54.763% 95.018%, 54.61% 95.139%, 54.462% 95.265%, 54.319% 95.396%, 54.179%
  95.53%, 54.042% 95.667%, 53.907% 95.806%, 53.772% 95.946%, 53.638% 96.085%,
  53.502% 96.224%, 53.365% 96.361%, 53.365% 96.361%, 52.858% 96.83%, 52.331%
  97.261%, 51.784% 97.657%, 51.219% 98.018%, 50.635% 98.347%, 50.035% 98.645%,
  49.418% 98.913%, 48.786% 99.154%, 48.139% 99.368%, 47.478% 99.558%, 47.478%
  99.558%, 47.21% 99.624%, 46.94% 99.681%, 46.669% 99.731%, 46.398% 99.774%,
  46.125% 99.813%, 45.852% 99.849%, 45.579% 99.884%, 45.306% 99.92%, 45.033%
  99.958%, 44.761% 100%`;
